<script setup>
import { ref, defineExpose, toRefs, defineProps, inject, watch } from "vue"
// import i18n from "@/i18n"
import basicFormCom from "./common/basicForm1.vue";
import compositionStructureCom from "./common/compositionStructure.vue";
import imageUploadCom from "./common/imageUpload.vue";
import customFieldCom from "./common/customField.vue";
import inputCom from "./common/customFieldInput.vue";

import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
// import { getProductsList} from "@/service"
const props = defineProps({
    hscodeList: {
        type: Array,
        default: () => []
    }
})
const detailInfo = inject('detailInfo')
const currentTabLang = inject('currentTabLang') //切换语言
//基本信息
const formData = ref({
    title: getLangValue("product-template.basicInfo"),
    fieldsList: [
        {
            label: getLangValue("product-template.productName"),
            key: 'productName',
            required: false,
            value: '',
        },
        {
            label: getLangValue("product-template.type"),
            required: false,
            key: 'type',
            value: '',
        },
        {
            label: getLangValue("product-template.inventory"),
            required: false,
            key: 'inventory',
            value: '',
            type: 'number',
        },
        {
            label: getLangValue("product-template.price"),
            required: false,
            key: 'price',
            value: '',
            type: 'number1',
            unit: '元',
        },
        {
            label: getLangValue("product-template.size"),
            required: false,
            key: 'size',
            value: '',
        },
        {
            label: getLangValue("product-template.color"),
            required: false,
            key: 'color',
            value: '',
        },
        {
            label: getLangValue("product-template.batch"),
            required: false,
            key: 'batch',
            value: '',
        },
        {
            label: getLangValue("product-template.batchValue"),
            required: false,
            key: 'batchValue',
            value: '',
        }
    ],
    addfieldsList: [],
})
//组成结构
const compositionStructureList = ref([
    {
        name: getLangValue('product-template.product_info_base_info_structure'),
        value: '',
        value_en: '',
        showDelete: true,
        tableList: [],
        tableData: [],
        inputVal: '',
        required: false,
        isShow: true,
    }
])
//组成结构数据库list
const { hscodeList } = toRefs(props)
//输入信息框
const inputList = ref([
    {
        children: [],
        deletable: false,
        extra: null,
        key: "product_washing_instructions",
        name: "产品洗涤使用说明",
        name_en: "产品洗涤使用说明",
        required: false,
        show: true,
        type: 1,
        value: null,
        showDelete: true,
        isShow: true,
    },
    {
        children: [],
        deletable: false,
        extra: null,
        key: "product_recycling_discarding_instructions",
        name: "产品回收/丢弃说明",
        name_en: "产品回收/丢弃说明",
        required: false,
        show: true,
        type: 1,
        value: null,
        showDelete: true,
        isShow: true,
    }
])
//上传框list
const uploadList = ref([
    {
        name: getLangValue('product-template.product_info_product_picture'),
        name_en: '',
        key: 'product_info_product_picture',
        type: 'productImg',
        showDelete: true,
        id: 'productsImgId',
        accept: '.png,.jpeg,.jpg,', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 50, //10M
        required: false,
        isShow: true,
    },
    {
        name: getLangValue('product-template.product_info_product_style'),
        type: 'productStyle',
        name_en: '',
        showDelete: true,
        key: 'product_info_product_style',
        id: 'productStyleId',
        accept: '.png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 50, //10M
        required: false,
        isShow: true,
        info: getLangValue("product-template.upload_info"),
    },
    {
        name: getLangValue('product-template.product_info_product_pattern'),
        type: 'version_2d',
        name_en: '',
        key: 'product_info_product_pattern',
        showDelete: true,
        id: 'productsversion_2dId',
        accept: '.png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 50, //10M
        required: false,
        isShow: true,
        info: getLangValue("product-template.upload_info"),
    },
    {
        name: getLangValue('product-template.product_info_virtual_fit'),
        type: 'fitting_virtual',
        key: "product_info_virtual_fit",
        showDelete: true,
        name_en: '',
        id: 'productsfitting_virtualId',
        accept: '.png,.jpeg,.jpg,', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 50, //10M
        required: false,
        isShow: true,
        fieldsList: [{
            name: getLangValueByKey('product-template.virtual_fit_hyperlink'), //字段名称
            name_en: getLangValueByKey('product-template.virtual_fit_hyperlink', 'en'), //字段名称
            key: '虚拟合身度超链接',
            required: false,  // 字段必填项
        }]
    },
    {
        name: getLangValue('product-template.product_trademark'),
        type: 'product_trademark',
        key: "product_trademark",
        showDelete: true,
        name_en: '',
        id: 'product_trademark',
        accept: '.png,.jpeg,.jpg,', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 50, //10M
        required: false,
        isShow: true,
    }
])
// 自定义的字段list 包含有上传框的
const customFieldsList = ref([
    {
        name: getLangValue('product-template.template_text'), // 文本名称
        fieldsList: [
            {
                name: getLangValue('product-template.template_text_field'), //字段名称 
                name_en: '',
                unit: '%', //字段单位
                key: '字段1',
                required: false,  // 字段必填项
            },
            // {
            //     name: '字段2', //字段名称
            //     unit: 'cm', //字段单位
            //     key: '字段2',
            // },
            // {
            //     name: '字段3', //字段名称
            //     unit: 'g/m³', //字段单位
            //     key: '字段3',
            // },
        ],
        isShow: false,
        showUpload: false,
        showDelete: true,
    },
    {
        name: getLangValue('product-template.template_text_attachment'), // 文本名称
        fieldsList: [
            {
                name: getLangValue('product-template.template_text_field'), //字段名称
                name_en: '',
                unit: '%', //字段单位
                key: '字段1',
                required: false, // 字段必填项
            },
            // {
            //     name: '字段2', //字段名称
            //     unit: 'cm', //字段单位
            // },
            // {
            //     name: '字段3', //字段名称
            //     unit: 'g/m³', //字段单位
            // },
        ],
        showUpload: true,
        isShow: false,
        id: 'customFiledUpload',
        accept: '', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 200, //200M
        showDelete: true,
    }
])
// 自定义字段校验
const checkForm = () => {
    let checkRes = true;
    for (let k in customFieldsList.value) {
        if (!customFieldsList.value[k].name) {
            checkRes = false;
            currentTabLang.value = 1;
            break;
        }
        if (!customFieldsList.value[k].name_en) {
            checkRes = false;
            currentTabLang.value = 2;
            break;
        }
    }
    return checkRes;
}

// 组成结构校验
const checkForm1 = () => {
    let checkRes = true;
    for (let k in compositionStructureList.value) {
        if (compositionStructureList.value[k].isShow && !compositionStructureList.value[k].value) {
            checkRes = false;
            // currentTabLang.value =1;
            break;
        }
        // //英文
        // if (compositionStructureList.value[k].isShow && !compositionStructureList.value[k].value_en) {
        //     currentTabLang.value =2;
        //     checkRes = false;
        //     break;
        // }
    }
    return checkRes;
}
// 筛选出重复项
const findDuplicates = (arr) => {
    const map = new Map();
    const duplicates = arr.filter(item => {
        if (!map.has(item)) {
            map.set(item, 1);
            return false;
        } else {
            map.set(item, map.get(item) + 1);
            return true;
        }
    });
    return duplicates;
};

// check 每个模板名称是否重复
const checkRepeat = () => {
    let checkRes = true;
    let arr = []
    let arr1 = []
    let moduleName = ''
    // 基本信息
    arr.push(formData.value.title)
    arr1.push(formData.value.title_en)
    // 组成结构
    for (let k in compositionStructureList.value) {
        if (compositionStructureList.value[k].isShow) {
            arr.push(compositionStructureList.value[k].name);
            arr1.push(compositionStructureList.value[k].name_en);
        }
    }
    // 上传框
    for (let k in uploadList.value) {
        if (uploadList.value[k].isShow) {
            arr.push(uploadList.value[k].name);
            arr1.push(uploadList.value[k].name_en);
        }
    }
    // 自定义字段
    for (let k in customFieldsList.value) {
        if (customFieldsList.value[k].isShow) {
            arr.push(customFieldsList.value[k].name);
            arr1.push(customFieldsList.value[k].name_en);
        }
    }
    // 去重
    // console.log(arr);
    let uniqueArr = Array.from(new Set(arr))
    let uniqueArr1 = Array.from(new Set(arr1))
    // console.log(uniqueArr);
    if (uniqueArr.length != arr.length) {
        // 重复名称
        const duplicates = findDuplicates(arr);
        moduleName = duplicates.join(',');
        checkRes = false
        currentTabLang.value = 1
    }

    if (uniqueArr1.length != arr1.length) {
        // 重复名称
        const duplicates = findDuplicates(arr1);
        moduleName = duplicates.join(',');
        checkRes = false
        currentTabLang.value = 2
    }
    return { checkRes, moduleName }
}

// 监听detailInfo 来组装数据
watch(detailInfo, (val) => {
    // 设置基本信息
    // 设置组成结构
    // 设置上传列表
    // 设置自定义字段
    const { product_info } = val
    if (typeof product_info == 'undefined') return
    // console.log('pi', product_info);
    // ------便利产品信息
    //基本信息
    const basicInfo = product_info.children[0];
    formData.value.title = basicInfo.name
    formData.value.title_en = basicInfo.name_en
    formData.value.fieldsList = basicInfo.children.filter(item => !item.extra || (item.extra && !item.extra.type)).map(item => {
        item.value = null
        // item.label = getEnZhName(item)
        item.label = item.name
        item.label_en = item.name_en
        return item
    });
    formData.value.addfieldsList = basicInfo.children.filter(item => item.extra && item.extra.type == 99).map(item => {
        item.value = null
        // item.label = getEnZhName(item)
        item.label = item.name
        item.label_en = item.name_en
        return item
    });
    // 组成结构
    const cSList = product_info.children.filter(item => item.key === 'product_info_base_info_structure')
    if (cSList.length) {
        compositionStructureList.value = cSList[0].children.map(item => {
            return {
                value: item.value,
                // name: getEnZhName(item),
                name: item.name,
                name_en: item.name_en,
                showDelete: true,
                tableList: [],
                tableData: [],
                inputVal: '',
                required: item.required,
                isShow: item.show,
                extra: {
                    template_type: item.extra?.template_type || 0, // 0是没有
                }
            }
        })
        // 获取数据

    } else {
        compositionStructureList.value = [];
    }
    // console.log(compositionStructureList.value);
    //上传框list
    // const upList = product_info.children.filter(item => (item.key == '产品图片' || item.key == "2D版型" || item.key == "虚拟合身度") && item.show)
    const upList = product_info.children.filter(item => (item.key.indexOf('product_info_product_picture') > -1
        || item.key.indexOf('product_info_product_style') > -1
        || item.key.indexOf('product_info_product_pattern') > -1
        || item.key.indexOf('product_info_virtual_fit') > -1
        || item.key.indexOf('product_trademark') > -1
    ))
    if (upList.length) {
        uploadList.value = []
        // 先显示产品图片的
        let arr1 = upList.filter(item => item.key.indexOf('product_info_product_picture') > -1).map((item, index) => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra && item.extra.type ? item.extra.type : 'productImg',
                key: item.key,
                showDelete: true,
                fileList: [],
                accept: item.extra && item.extra.accept ? item.extra.accept : '.png,.jpeg,.jpg,',
                fileMaxSize: 1024 * 1024 * 50,
                info: '',
                required: item.required,
                isShow: item.show,
                id: item.extra && item.extra.id ? item.extra.id : 'productsImgId' + index,
            }
        })
        uploadList.value = [...uploadList.value, ...arr1]
        let arr2 = upList.filter(item => item.key.indexOf('product_info_product_style') > -1).map((item, index) => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra && item.extra.type ? item.extra.type : 'productStyle',
                key: item.key,
                showDelete: true,
                fileList: [],
                accept: item.extra && item.extra.accept ? item.extra.accept : '.png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi',
                fileMaxSize: 1024 * 1024 * 50,
                info: getLangValue("product-template.upload_info"),
                required: item.required,
                isShow: item.show,
                id: item.extra && item.extra.id ? item.extra.id : 'productStyleId' + index,
            }
        })
        uploadList.value = [...uploadList.value, ...arr2]

        let arr3 = upList.filter(item => item.key.indexOf('product_info_product_pattern') > -1).map((item, index) => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra && item.extra.type ? item.extra.type : 'version_2d',
                key: item.key,
                showDelete: true,
                fileList: [],
                accept: item.extra && item.extra.accept ? item.extra.accept : '.png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi',
                fileMaxSize: 1024 * 1024 * 50,
                info: getLangValue("product-template.upload_info"),
                required: item.required,
                isShow: item.show,
                id: item.extra && item.extra.id ? item.extra.id : 'productsversion_2dId' + index,
            }
        })
        uploadList.value = [...uploadList.value, ...arr3]
        let arr4 = upList.filter(item => item.key.indexOf('product_info_virtual_fit') > -1).map(item => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra.type,
                key: item.key,
                showDelete: true,
                fileList: [],
                accept: item.extra.accept,
                fileMaxSize: item.extra.fileMaxSize,
                info: '',
                required: item.required,
                isShow: item.show,
                id: item.extra.id,
                fieldsList: item.children ? item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: '', //字段单位
                        key: ele.key,
                        value: '',
                        required: ele.required,
                        // isShow: ele.show,
                    }
                }) : [],
            }
        })
        uploadList.value = [...uploadList.value, ...arr4]
        // 图标
        let arr5 = upList.filter(item => item.key.indexOf('product_trademark') > -1).map((item, index) => {
            return {
                name: item.name,
                name_en: item.name_en,
                type: item.extra?.type || 'product_trademark',
                key: item.key,
                showDelete: true,
                fileList: [],
                accept: item.extra?.accept || '.png,.jpeg,.jpg,',
                fileMaxSize: item.extra?.fileMaxSize || 1024 * 1024 * 50,
                info: '',
                required: item.required,
                isShow: item.show,
                id: item.extra && item.extra.id ? item.extra.id : 'product_trademark' + index,
            }
        })
        uploadList.value = [...uploadList.value, ...arr5]
    } else {
        uploadList.value = [];
    }
    // 自定义是输入框数据
    const inputList1 = product_info.children.filter(item => item.key.indexOf('product_washing_instructions')> -1 || item.key.indexOf('product_recycling_discarding_instructions')> -1);
    if (inputList1.length) {
        inputList.value = inputList1.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                showDelete: true,
                isShow: item.show,
                key: item.key,
            }
            return m
        })
    } else {
        inputList.value = [];
    }

    //自定义的字段list
    const csFieldList = product_info.children.filter(item => item.extra && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (csFieldList.length) {
        customFieldsList.value = csFieldList.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                fieldsList: [],
                showUpload: false,
                showDelete: true,
                isShow: item.show,
            }
            if (item.children)
                m.fieldsList = item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: '',
                        required: ele.required,
                        isShow: ele.show,
                    }
                })
            if (item.extra.myKey == "文本项+附件项") {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.id = item.extra.id
                m.accept = item.extra.accept
                m.fileList = item.extra.fileList
                m.fileMaxSize = item.extra.fileMaxSize
            }
            return m
        })
    } else {
        customFieldsList.value = [];
    }
},)

defineExpose({
    formData,
    compositionStructureList,
    uploadList,
    customFieldsList,
    checkForm,
    checkForm1,
    checkRepeat,
    inputList
})

// watch(compositionStructureList, (val) => {
//     console.log(val);
// })
</script>
<template>
    <div class="productInfo">
        <!-- 基本信息 -->
        <basicFormCom :formData="formData" />
        <!-- 组成结构 -->
        <compositionStructureCom v-model:compositionStructureList="compositionStructureList" :hscodeList="hscodeList" />
        <!-- 图片上传部分 -->
        <imageUploadCom v-model:uploadList="uploadList" />
        <!-- 输入信息框 -->
        <inputCom v-model:customFieldsList="inputList" />
        <!-- 验证部分 -->
        <!-- 自定义字段部分 -->
        <customFieldCom v-model:customFieldsList="customFieldsList" />
    </div>
</template>
<style scoped></style>